import { useEffect, useState } from 'react'
import { Box, makeStyles, TextField } from '@material-ui/core'

import { useNotification } from 'hooks'

const useStyles = makeStyles({
    stepText: {
        fontSize: '20px',
        fontWeight: 'bold',
        wordBreak: 'break-word'
    }
})

type Props = {
    isEditMode: boolean
    title: string
    onUpdate: (_value: string) => void
}
export const StepTitle = ({ isEditMode, title, onUpdate }: Props) => {
    const classes = useStyles()

    const { showErrorNotification } = useNotification()

    const [titleField, setTitleField] = useState(title)

    useEffect(() => {
        setTitleField(title)
    }, [title])

    if (!isEditMode) return <Box className={classes.stepText}>{title}</Box>

    return (
        <TextField
            label="Step title"
            value={titleField}
            variant="filled"
            fullWidth
            onBlur={() => {
                if (!titleField.length) {
                    showErrorNotification('Title cannot be empty')
                    setTitleField(title)
                    return
                }
                // we need to make update only if field was changed
                if (title !== titleField) onUpdate(titleField)
            }}
            onClick={e => e.stopPropagation()}
            onChange={event => setTitleField(event.target.value)}
        />
    )
}
